import React from 'react'
import styles from './styles.scss'

import IconComponent from '@/components/commons/IconComponent'

const InputNumber = props => {

  const inputNumber = React.createRef()

  const handleAddInputNumber = () => {
    ++inputNumber.current.value
    props.onChange({ target: inputNumber.current })
  }

  const handleRemoveInputNumber = () => {
    --inputNumber.current.value
    props.onChange({ target: inputNumber.current })
  }

  return (
    <div className={styles['wrapper-input-number']}>
      {props.unit && <div className={styles['wrapper-input-number__append']}>{props.unit}</div>}

      <span
        className={styles['wrapper-input-number-icon']}
        onClick={handleAddInputNumber}
        aria-hidden={true}
      >
        <IconComponent icon="sort-up" />
      </span>
      {/* <div className={styles['wrapper-input-number__divider-icon']} /> */}
      <span
        className={styles['wrapper-input-number-icon']}
        onClick={handleRemoveInputNumber}
        aria-hidden={true}
      >
        <IconComponent
          icon="sort-down"

        />
      </span>
      <input
        ref={inputNumber}
        type="number"
        className={styles['wrapper-input']}
        {...props}
      />
    </div>
  )
}

export default InputNumber


// WEBPACK FOOTER //
// ./src/components/InputNumber/index.js